module.exports = __webpack_public_path__ + "images/banners/pages_iphone/smartphone_e600eed2018ab0590720a3f8a36a2789.png";